<template>
  <el-container>
    <el-header><headers /></el-header>
    <el-main><slot></slot></el-main>
    <footers />
  </el-container>
</template>
<script>
import headers from "./TheLayoutHeader";
import footers from "./TheLyoutFooter";
export default {
  components: {
    headers,
    footers
  }
};
</script>
<style lang="less" scoped>
.el-container {
  height: 100%;
  width: 100%;
  .el-header,
  .el-main,
  .el-footer {
    margin: 0;
    padding: 0;
    text-align: center;
    display: inline-block;
    height: auto !important;
  }
  .el-main {
    background-color: #f4f4f4;
    overflow: visible;
    padding-bottom: 50px;
  }
}
</style>
